<div class="order-save-controls" [class.split]="splitSave">
  <button
    *ngIf="splitSave && !showOptionsMenu"
    mat-raised-button
    color="primary"
    type="button"
    (click)="onSave('SAVE')"
  >
    SAVE
  </button>
  <button
    *ngIf="!splitSave && !showOptionsMenu"
    mat-button
    [matMenuTriggerFor]="menu"
    class="save-menu-trigger"
  >
    <mat-icon>more_vert</mat-icon>
    <span>SAVE</span>
  </button>
  <button
    *ngIf="showOptionsMenu"
    mat-raised-button
    color="primary"
    type="button"
    [matMenuTriggerFor]="menu"
  >
    OPTIONS
  </button>
</div>
<mat-menu #menu="matMenu">
  <ng-container *ngIf="isReturned">
    <button mat-menu-item type="button" (click)="onSave('PRINT')">
      PRINT
    </button>
    <button mat-menu-item type="button" (click)="onSave('EMAIL')">
      EMAIL
    </button>
    <button
      *ngIf="canDelete"
      mat-menu-item
      type="button"
      (click)="onSave('DELETE')"
    >
      DELETE
    </button>
  </ng-container>
  <ng-container *ngIf="isDispensed">
    <button mat-menu-item type="button" (click)="onSave('DUPLICATE')">
      DUPLICATE
    </button>
    <button mat-menu-item type="button" (click)="onSave('EXCHANGE')">
      EXCHANGE
    </button>
    <button mat-menu-item type="button" (click)="onSave('NEW RX')">
      NEW RX
    </button>
    <button mat-menu-item type="button" (click)="onSave('RE-DO')">
      RE-DO
    </button>
    <button mat-menu-item type="button" (click)="onSave('REPAIR')">
      REPAIR
    </button>
    <button mat-menu-item type="button" (click)="onSave('RETURN')">
      RETURN
    </button>
    <button mat-menu-item type="button" (click)="onSave('PRINT')">
      PRINT
    </button>
    <button mat-menu-item type="button" (click)="onSave('EMAIL')">
      EMAIL
    </button>
    <button
      *ngIf="canDelete"
      mat-menu-item
      type="button"
      (click)="onSave('DELETE')"
    >
      DELETE
    </button>
  </ng-container>
  <ng-container *ngIf="!showOptionsMenu">
    <ng-container *ngIf="variant === 'repair'; else orderSaveOptions">
      <button mat-menu-item type="button" style="margin-left:10px;" (click)="onSave('ORDERED')">
        REPAIR
      </button>
      <button mat-menu-item type="button" style="margin-left:10px;" (click)="onSave('SAVE')">
        WARRANTY
      </button>
      <button mat-menu-item type="button" style="margin-left:10px;" (click)="onSave('SAVE')">
        SAVE/HOLD
      </button>
      <button mat-menu-item type="button" style="margin-left:10px;" (click)="onSave('SAVE')">
        VOID
      </button>
    </ng-container>
    <ng-template #orderSaveOptions>
      <ng-container *ngIf="variant === 'prescription'; else frameSaveOptions">
        <button
          mat-menu-item
          type="button"
          style="margin-left:10px;"
          [disabled]="!canSave"
          (click)="onSave('SAVE')"
        >
          SAVE RX
        </button>
        <button mat-menu-item type="button" style="margin-left:10px;" (click)="onSave('VOID RX')">
          VOID
        </button>
      </ng-container>
      <ng-template #frameSaveOptions>
      <button mat-menu-item type="button" style="margin-left:10px;" (click)="onSave('ORDERED FRAME')">
        ORDERED FRAME
      </button>
      <button mat-menu-item type="button" style="margin-left:10px;" (click)="onSave('ORDERED ON APPROVAL')">
        ORDERED ON APPROVAL
      </button>
      <button mat-menu-item type="button" style="margin-left:10px;" (click)="onSave('SEND TO STACK')">
        TO ORDER
      </button>
      <button mat-menu-item type="button" style="margin-left:10px;" (click)="onSave('SAVE/HOLD')">
        SAVE / HOLD
      </button>
      <button mat-menu-item type="button" style="margin-left:10px;" (click)="onSave('SAVE/QUOTE')">
        SAVE QUOTE
      </button>
      <button mat-menu-item type="button" style="margin-left:10px;" (click)="onSave('ADD TO CART')">
        ADD TO CART
      </button>
      <button mat-menu-item type="button" style="margin-left:10px;" (click)="onSave('VOID')">
        VOID
      </button>
      </ng-template>
    </ng-template>
  </ng-container>
</mat-menu>
